import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import './styles/switch.scss'


const Switch = (props) => {
    const handleChange = () => {
        props.onChange(!props.switchValue);
    };

    const stateClass = classNames({
        'flipswitch__msg--on' : props.switchValue,
        'flipswitch__msg--off' : !props.switchValue
    });
    
    return (
    <label className="flipswitch" title={props.title}>
        <input type="checkbox" className="flipswitch__check" onChange={handleChange}
               checked={props.value}/>
        <div className="flipswitch__switch">
            <div className="flipswitch__switch-button"></div>
        </div>
        <div className="flipswitch__msg">
            <span className={stateClass}>{props.value ? 'ON' : 'OFF'}</span>
        </div>
    </label>
    )
};


Switch.propTypes = {
    value: PropTypes.bool.isRequired,
    title: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default Switch


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/Switch/Switch.js